export const baseUrl = 'https://api.themoviedb.org/3'
export const imgUrl = 'https://image.tmdb.org/t/p/original'
